/** @type {import('../help-index.js').HelpSidebarItem} */
export const LAB_CON_CONCEPTS_ITEM = {
  id: 'concepts_main',
  screenId: 'lab-con-concepts',
  label: 'Conceptos',
  description: 'Haberes, no remunerativos y descuentos de la liquidación.',
  detail: {
    sections: [
      {
        title: 'Para qué sirve',
        intro:
          'Configurás las líneas que componen el recibo de sueldo: sueldo básico, aportes, horas extra, descuentos, SAC, etc. Cada concepto define cómo se calcula el importe y cómo se informa al LSD/AFIP.',
      },
      {
        title: 'Lista',
        bullets: [
          'Interruptor «Solo conceptos activos» — activo por defecto.',
          'Columnas: Código, Cód. LSD, Descripción, Tipo, Forma de cálculo, Valor, SAC, Origen (Sistema / Usuario), Cód. AFIP, Activo.',
          'Tocá una fila para editar. Botón + para concepto nuevo. Podés exportar.',
        ],
      },
      {
        title: 'Campos del concepto',
        fields: [
          { label: 'Código', description: 'Identificador interno (máx. 20 caracteres, único). Obligatorio.' },
          {
            label: 'Código LSD',
            description: 'Opcional, máx. 10 caracteres. Código que diste de alta en el Libro de Sueldos Digital; varios conceptos pueden compartirlo.',
          },
          { label: 'Descripción', description: 'Nombre visible en el recibo. Obligatoria.' },
          {
            label: 'Tipo',
            description: 'Remunerativo, no remunerativo o descuento.',
          },
          {
            label: 'Forma de cálculo',
            description: 'Sueldo básico (de categoría), porcentaje sobre una base, importe fijo, antigüedad, cantidad × valor unitario, o SAC (% del mejor sueldo).',
          },
          {
            label: 'Base de cálculo',
            description: 'Para porcentajes: sobre el básico o sobre el total remunerativo (opcional según forma de cálculo).',
          },
          {
            label: 'Valor',
            description: 'Según la forma: % (ej. 11 para aportes), importe fijo, valor unitario, etc. Los porcentajes se ingresan como número entero (11 = 11%).',
          },
          { label: 'Genera SAC', description: 'Marcá si el concepto entra en el cálculo del aguinaldo.' },
          {
            label: 'Aplica a todos los empleados',
            description: 'Solo al crear. Si está marcado, entra en la liquidación de todos; si no, lo asignás empleado por empleado en su legajo.',
          },
          {
            label: 'Concepto AFIP (LSD) / Tipo AFIP',
            description: 'Vinculación con el catálogo AFIP habilitado en LSD → Configuración. Tipo 1 remunerativo, 2 no remunerativo, 3 descuento.',
          },
          {
            label: 'Bases LSD / AFIP',
            description: 'Marcas 0/1 del TXT de relación de conceptos: SIPA, INSSJyP, obra social (rem 4 / rem 8), FSR, ART (rem 9), etc. Desmarcá OS/FSR si el haber no debe entrar en la base de obra social.',
          },
        ],
      },
      {
        title: 'Conceptos del sistema',
        paragraphs: [
          'Algunos conceptos vienen precargados (Origen «Sistema»). Podés ajustar código interno, código LSD, valor, SAC, códigos AFIP y bases LSD, pero no cambiar descripción, tipo ni forma de cálculo desde la pantalla.',
        ],
      },
      {
        title: 'Editar y desactivar',
        bullets: [
          'Casilla Activo al editar — desmarcá para dejar de usar el concepto en liquidaciones nuevas.',
          'El código interno no puede repetirse al crear uno nuevo.',
        ],
      },
      {
        title: 'Uso en la liquidación',
        paragraphs: [
          'Al generar recibos (Laboral → Liquidación → Recibos) el motor aplica conceptos «a todos» más los asignados a cada empleado, más novedades del período.',
        ],
      },
    ],
  },
}
